import { render, staticRenderFns } from "./Design.vue?vue&type=template&id=4b5641a4&scoped=true&"
import script from "./Design.vue?vue&type=script&lang=js&"
export * from "./Design.vue?vue&type=script&lang=js&"
import style0 from "./Design.vue?vue&type=style&index=0&id=4b5641a4&prod&lang=css&"
import style1 from "./Design.vue?vue&type=style&index=1&id=4b5641a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5641a4",
  null
  
)

export default component.exports